module.exports = __webpack_public_path__ + "media/images/lp/1/voice3-close-85f0abd90f155ae83b50c7b697ed8da9.png";